var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimulation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.18-104Q333-104 258.5-177.5T184-357v-195q0-11.58 11.5-16.29Q207-573 216-565l140 140q12 12 12 27.57 0 15.58-11.74 26.9Q345-359 329.03-359q-15.96 0-27.03-11l-41-41v54q0 74.24 51.96 125.12Q364.92-181 439.17-181q73.83 0 126.33-50.88T618-357v-131q-37-12-60-43.09-23-31.08-23-70.68 0-39.23 23.32-71.48Q581.65-705.51 618-718v-140q0-15.35 10.68-26.67 10.67-11.33 27-11.33Q672-896 683-884.67q11 11.32 11 26.67v140q36 13 59 45.05t23 70.96q0 38.9-23 70.95Q730-499 694-488v131q0 105.42-74.32 179.21Q545.35-104 439.18-104Zm216.03-454Q674-558 687-570.62t13-31.27Q700-621 687.47-634q-12.54-13-31.07-13-18.95 0-32.18 12.82Q611-621.35 611-602.25q0 19.11 12.71 31.68t31.5 12.57Zm.79-45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulation);
export default __webpack_public_path__ + "static/media/simulation.4b807f648c48c1acdaa0c29635ce0d91.svg";
export { ForwardRef as ReactComponent };